export const textMap = {
  education: {
    en: [
      {
        highschool: "High-School",
        graduate: "Graduate",
        phd: "Ph.D",
        postdoc: "Post Doc",
        other: "Other"
      }
    ],
    dk: [
      {
        folkeskole: "9. klasse",
        gymnasial: "Gymnasial",
        erhvervsudannelse: "Erhvervsudannelse",
        bachelor: "Bachelor",
        kandidat: "Kandidat",
        phd: "Ph.D",
        andet: "Andet"
      }
    ]
  },
  leaderExp: {
    dk: [{ "<5": "<5 år", "5-10": "5-10 år", "10+": "10+ år" }],
    en: [
      {
        "<5": "<5 years",
        "5-10": "5-10 years",
        "10+": "10+ years"
      }
    ]
  }
};

export const reportDetails = {
  "twelvesections": {},
  "twentyfivesections": {},
  "profile": {
    headline: {
      en: "Transactional Analysis",
      dk: "Transanktional Analyse",
      x: 40,
      y: 150
    },

    id: "printPie",
    questionsPlace: 250,

    image: {
      x: 25,
      y: 25,
      w: 175,
      h: 200
    },
    percent: 18
  },
  "360": {
    headline: {
      en: "Evalueringsrapport",
      dk: "Evaluation Report",
      x: 55,
      y: 150
    },

    id: "printResultChart",
    questionsPlace: 170,

    image: {
      x: 0,
      y: 30,
      w: 200,
      h: 80
    },
    percent: 9.5
  }
};



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultCollection/ResultsList/text.js